import { type IFooterLinks } from './footer.component';

const prefix = '_ui.footer';

/** `helpUrl` is an absolute URL, not a wording key — see {@link IFooterItem.url}. */
export function getFooterLinks(helpUrl: string): IFooterLinks[] {
  return [
    {
      header: `${prefix}.myre.header`,
      items: [
        {
          name: `${prefix}.myre.userGuide.name`,
          url: helpUrl,
          isActive: true,
          target: '_blank',
        },
        {
          name: `${prefix}.myre.solution.name`,
          url: `${prefix}.myre.solution.url`,
          isActive: true,
          target: '_blank',
        },
        {
          name: `${prefix}.myre.about.name`,
          url: `${prefix}.myre.about.url`,
          isActive: true,
          target: '_blank',
        },
        {
          name: `${prefix}.myre.customerExperiences.name`,
          url: `${prefix}.myre.customerExperiences.url`,
          isActive: true,
          target: '_blank',
        },
      ],
    },
    {
      header: `${prefix}.resources.header`,
      items: [
        {
          name: `${prefix}.resources.blog.name`,
          url: `${prefix}.resources.blog.url`,
          isActive: true,
          target: '_blank',
        },
        {
          name: `${prefix}.resources.press.name`,
          url: `${prefix}.resources.press.url`,
          isActive: true,
          target: '_blank',
        },
        {
          name: `${prefix}.resources.jobs.name`,
          url: `${prefix}.resources.jobs.url`,
          isActive: true,
          target: '_blank',
        },
        {
          name: `${prefix}.resources.mediaKit.name`,
          url: `${prefix}.resources.mediaKit.url`,
          isActive: true,
          target: '_blank',
        },
      ],
    },
    {
      header: `${prefix}.contact.header`,
      items: [
        {
          name: `${prefix}.contact.linkedIn.name`,
          url: `${prefix}.contact.linkedIn.url`,
          isActive: true,
          target: '_blank',
        },
        {
          name: `${prefix}.contact.twitter.name`,
          url: `${prefix}.contact.twitter.url`,
          isActive: true,
          target: '_blank',
        },
        {
          name: `${prefix}.contact.facebook.name`,
          url: `${prefix}.contact.facebook.url`,
          isActive: true,
          target: '_blank',
        },
      ],
    },
    {
      header: `${prefix}.legal.header`,
      items: [
        {
          name: `${prefix}.legal.cookiesPolicy.name`,
          url: `${prefix}.legal.cookiesPolicy.url`,
          isActive: true,
          target: '_blank',
        },
        {
          name: `${prefix}.legal.legalInformation.name`,
          url: `${prefix}.legal.legalInformation.url`,
          isActive: true,
          target: '_blank',
        },
        {
          name: `${prefix}.legal.terms.name`,
          url: `${prefix}.legal.terms.url`,
          authRequired: true,
          isActive: true,
          target: '_blank',
        },
        {
          name: `${prefix}.legal.privacyPolicy.name`,
          url: `${prefix}.legal.privacyPolicy.url`,
          isActive: true,
          target: '_blank',
        },
        {
          name: `${prefix}.legal.gdpr.name`,
          url: `${prefix}.legal.gdpr.url`,
          isActive: true,
          target: '_blank',
        },
      ],
    },
  ];
}
